import React from 'react';
import './App.css';
import { useState, useEffect } from 'react';
import Country from './components/Country/Country';


function App() {
  // State declaration
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    fetch('https://restcountries.eu/rest/v2/all')
      .then(res => res.json())
      .then(data => setCountries(data))
      .catch(err => console.log(err))
  }, [])

  return (
    <div className="App">
      <div>
        <h2>Country Lists and Details</h2>
      </div>
      <div className="display-countries">
        <table class="table" border="1">
          <thead>
            <tr>
              <th >No.</th>
              <th>Country</th>
              <th>Area (km<sup>2</sup>)</th>
              <th>Capital</th>
              <th>Flag</th>
              <th>Language</th>
              <th>Currency</th>
              <th>Population</th>
              <th>Timezones</th>
              <th>Region</th>
            </tr>
          </thead>
          {
            countries.map((country, idx) => <Country key={country.alpha3Code} index={idx} country={country}> </Country>)
          }
        </table>
      </div>
      <p>Developed by <a href="https://github.com/bdmostafa" target="_blank">Mostafa</a> </p>
    </div>
  );
}

export default App;
